<template>
  <div>
    <div class="d-flex align-center justify-center">
      <div class="form-content text-center" style="width:100% !important">
        <v-data-table
          :headers="headers"
          :disable-sort="true"
          :items="[data]"
          hide-default-footer
          class="elevation-0 w-100"
          mobile-breakpoint="9999"
        >
          <template v-slot:item.questionName="{ item }">
            <span>{{ item.questionName || item.questionKey || '-' }}</span>
          </template>
          <template v-slot:item.questionKey="{ item }">
            <span>{{ item.questionKey || '-' }}</span>
          </template>
          <template v-slot:item.status="{ item }">
            <v-chip small :color="item.mathRecord && item.mathRecord.isCompleted ? 'success' : 'orange'" dark>
              {{ item.mathRecord && item.mathRecord.isCompleted ? 'Completed' : 'Ongoing' }}
            </v-chip>
          </template>
          <template v-slot:item.grade="{ item }">
            <v-img contain max-width="48" :src="gradeImage(item)" />
          </template>
          <template v-slot:item.stars="{ item }">
            <v-rating v-if="item.mathRecord" :value="item.mathRecord.topStar" length="3" readonly dense background-color="amber" color="amber" size="22" />
            <span v-else>-</span>
          </template>
          <template v-slot:item.timestampCreated="{ item }">
            <span v-if="item.timestampCreated">{{ $moment(item.timestampCreated).format('DD/MM/YY HH:mm') }}</span>
            <span v-else>-</span>
          </template>
          <template v-slot:item.timestampUpdated="{ item }">
            <span v-if="item.mathRecord && item.mathRecord.timestampUpdated">{{ $moment(item.mathRecord.timestampUpdated).format('DD/MM/YY HH:mm') }}</span>
            <span v-else>-</span>
          </template>
        </v-data-table>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  components: {
   
    //
  },
  computed: {
    size() {
      const size = { xs: "small", sm: "small", lg: "large", xl: "x-large" }[
        this.$vuetify.breakpoint.name
      ];
      return size ? { [size]: true } : {};
    },
    ...mapState({
      auth: (state) => state.auth.data,
    }),
  },
  props: ["data", "headers"],
  methods: {
    gradeImage(item) {
      const grade = item && item.mathRecord && item.mathRecord.grade;
      const shields = {
        A: require("@/assets/math/shields/gradeA.png"),
        B: require("@/assets/math/shields/gradeB.png"),
        C: require("@/assets/math/shields/gradeC.png"),
        F: require("@/assets/math/shields/gradeF.png"),
        X: require("@/assets/math/shields/gradeX.png"),
      };
      return shields[grade] || shields.X;
    },
  },
};
</script>